import shouldForwardProp from '@styled-system/should-forward-prop';
import styled from 'styled-components';

const ModalOverlay = styled.div.withConfig({
  shouldForwardProp: (prop) => shouldForwardProp(prop) && prop !== 'ownerState',
})`
  &&&& {
    background-color: ${({ theme }) => theme.scTheme.palette.inverted[100]};
    height: 100%;
    position: absolute;
    width: 100%;
  }
`;

export default ModalOverlay;
